import React from "react";
import { Grid, MenuItem, Select } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageDropdown = ({ page }) => {
  const navigate = useNavigate();

  return (
    <Grid textAlign="right" item className="form-lable" xs={12} lg={6} md={6}>
      {/* <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={page}
        onChange={(e) => navigate(`/${e.target.value}`)}
      >
        <MenuItem value="property">Properties</MenuItem>
        <MenuItem value="products">Products</MenuItem>
        <MenuItem value="enquiry">Enquiry</MenuItem>
      </Select> */}
    </Grid>
  );
};

export default PageDropdown;
